export default "__VITE_ASSET__73_xP5Cv__"